<div id="theme-changer" (click)="changeTheme()"><fa-icon icon="circle-half-stroke"></fa-icon></div>
